import React from "react";
import CountrySelector from "../../../../components/common/CountrySelector";
import { DictionaryFieldType } from "../../constants";
import { Field } from "../Fields";

/** Formularz rekordu korzysta z pól zadeklarowanych przez konkretny słownik. */
export default function RecordEntryFields({
  definition,
  value,
  onChange,
  disabled,
}) {
  const set = (key, next) => onChange({ ...value, [key]: next });
  return definition.fields.map((field) =>
    field.type === DictionaryFieldType.COUNTRY ? (
      <div className="premium-field" key={field.key}>
        <CountrySelector
          name={`dictionary-${definition.kind}-${field.key}`}
          label={field.label}
          data={value[field.key] || ""}
          required={String(field.required)}
          disabled={disabled}
          onDataChange={(event) => set(field.key, event.target.value)}
        />
      </div>
    ) : (
      <Field
        key={field.key}
        label={field.label}
        required={field.required}
        multiline={field.multiline}
        maxLength={field.maxLength}
        value={value[field.key] || ""}
        onChange={(event) => set(field.key, event.target.value)}
      />
    ),
  );
}
